import React, { useEffect } from "react"
import types from "prop-types"
import { workflowConditionShape } from "utils/propTypeShapes"
import { EQUAL_OR_OLDER_PROPERTY_OP } from "utils/workflowHelpers"

const DefineSubmissionAgeOperator = ({ changeConditionOperator, condition }) => {
  useEffect(() => {
    if (condition.operator !== EQUAL_OR_OLDER_PROPERTY_OP) {
      changeConditionOperator(EQUAL_OR_OLDER_PROPERTY_OP)
    }
  /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [])

  return (
    <span>is</span>
  )
}

DefineSubmissionAgeOperator.propTypes = {
  changeConditionOperator: types.func.isRequired,
  condition: workflowConditionShape.isRequired,
}

export default DefineSubmissionAgeOperator
